import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import Spinner, { SpinnerColorType } from '../Spinner/Spinner'

import './Button.css'

const Button = ({ handleClick, isEnabled, isRadius, isAccent, isPaid, children, isLoading }) => {
  let content = <div styleName="text">{children}</div>
  if (isLoading) {
    content = (
      <div styleName="spinner">
        <Spinner color={SpinnerColorType.WHITE} />
      </div>
    )
  }

  let dom = <div styleName={`disabled-button${isRadius ? ' radius' : ''}`}>{content}</div>

  if (isEnabled && !isLoading) {
    if (isAccent && handleClick != null) {
      dom = (
        <div styleName={`enabled-button${isRadius ? ' radius' : ''}`} onClick={handleClick}>
          {content}
        </div>
      )
    } else if (!isPaid) {
      dom = (
        <div styleName={`nonPaid-button${isRadius ? ' radius' : ''}`} onClick={handleClick}>
          {content}
        </div>
      )
    } else {
      dom = (
        <div styleName={`base-button${isRadius ? ' radius' : ''}`} onClick={handleClick}>
          {content}
        </div>
      )
    }
  }
  return dom
}

Button.propTypes = {
  handleClick: PropTypes.func,
  isEnabled: PropTypes.bool.isRequired,
  isRadius: PropTypes.bool.isRequired,
  isAccent: PropTypes.bool.isRequired,
  isPaid: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
}

Button.defaultProps = {
  isRadius: true,
  isEnabled: true,
  isAccent: true,
  isPaid: true,
  isLoading: false
}

export default compose(pure)(Button)
